<template>
  <v-card
      flat
      outlined
      class="mb-3 pa-3 subtitle-1"
  >
    <div class="d-flex justify-space-between align-center">
      <div
          class="primary--text"
          style="cursor: pointer!important;"
          @click="goToTicket"
      >
        #{{ id }}
      </div>
    </div>
    <div class="font-weight-medium body-2 mb-4">{{ name }}</div>
    <div class="d-flex justify-start align-center">
      <v-icon size="small" class="mr-2">mdi-clock-time-nine</v-icon>
      <div class="body-2">{{ !deadline ? "Без дедлайна" : deadlineDate }}</div>
    </div>
    <div class="d-flex justify-start align-center">
      <v-icon size="small" class="mr-2">mdi-account-circle</v-icon>
      <div class="body-2">{{ !user ? "Сотрудник не назначен" : user }}</div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'BoardItem',
  components: {

  },
  props: ["name", "user", "deadline", "uid", "id"],
  data: () => ({
    actions: [

    ]
  }),
  computed: {
    deadlineDate() {
      const unix = this.deadline;
      let date = new Date(unix * 1000);
      let hours = date.getHours();
      let minutes = "0" + date.getMinutes();
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      let formattedTime = hours + ':' + minutes.substr(-2);
      let formattedDate = day + '-' + month + '-' + year;
      return formattedDate + ' ' + formattedTime;
    },
  },
  methods: {
    goToTicket() {
      window.open(`/#/desc/ticket/${this.uid}`, "_blank")
    }
  },
  mounted() {

  }
}
</script>